module.exports = __webpack_public_path__ + "static/media/lg62.fecc8ab1.png";